import { ShopifyProduct } from "@/lib/shopify";
import { excludeSpecialProducts } from "@/lib/bagCategories";
import ShopifyProductCard from "@/components/ShopifyProductCard";
import ProductSkeleton from "@/components/ProductSkeleton";

interface ShopifyProductGridProps {
  products: ShopifyProduct[];
  loading?: boolean;
  columns?: 2 | 3 | 4;
  emptyMessage?: string;
}

const ShopifyProductGrid = ({
  products,
  loading = false,
  columns = 3,
  emptyMessage = "No products found.",
}: ShopifyProductGridProps) => {
  if (loading) return <ProductSkeleton count={columns === 4 ? 8 : 6} />;

  if (products.length === 0) {
    return (
      <p className="text-center font-body text-muted-foreground py-20">
        {emptyMessage}
      </p>
    );
  }

  const gridCols =
    columns === 4
      ? "grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
      : columns === 2
      ? "grid-cols-2"
      : "grid-cols-2 md:grid-cols-3";

  const filtered = excludeSpecialProducts(products);

  return (
    <div className={`grid ${gridCols} gap-4 md:gap-6`}>
      {filtered.map((product, i) => (
        <ShopifyProductCard key={product.node.id} product={product} index={i} />
      ))}
    </div>
  );
};

export default ShopifyProductGrid;
